import { render, staticRenderFns } from "./RecoveryEmail.vue?vue&type=template&id=79077820"
import script from "./RecoveryEmail.vue?vue&type=script&lang=js"
export * from "./RecoveryEmail.vue?vue&type=script&lang=js"
import style0 from "./RecoveryEmail.vue?vue&type=style&index=0&id=79077820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports